Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.examplePostAPiMethod = "POST";
exports.exampleGetAPiMethod = "GET";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "SalesReporting";
exports.labelBodyText = "SalesReporting Body";
exports.bodyText = "bodyText";
exports.titleText = "titleText";
exports.inputText = "inputTextTitle";
exports.customizeText = "Customize";

exports.btnExampleTitle = "CLICK ME";
exports.stringsListPage_selectAll = "Select All";
exports.stringsListPage_select_store = "Select Store";
exports.stringsListPage_all_stores = "All Stores";
exports.stringsListPage_select_region = "Select Region";
exports.salesReportingEndPoint= {
  "Orders Sales Report": "bx_block_salesreporting/generate_excel_report",
  "Orders Revenue Report": "bx_block_salesreporting/order_revenue_report",
  "Laundry Sales & Revenue Report": "bx_block_salesreporting/generate_excel_for_sales_and_revenue_report",
  "Daily Sales Report": "bx_block_salesreporting/salesreportings/generate_excel_daily_sales_report",
  "Trend products Sales Report": "bx_block_salesreporting/salesreportings/trend_product_sales",
  "Adjustment Report": "bx_block_salesreporting/adjustment_report/generate_adjustment_report",
  "Consolidated Sales & Revenue Report": "bx_block_cffinancereport2/generate_finance_report",
  "Section & Service Sales Report": "bx_block_salesreporting/generate_excel_for_section_sales_report",
  "Promotion Sales Report": "bx_block_salesreporting/generate_excel_for_promotion_sales_report",
  "Sales Comparison Report": "bx_block_salesreporting/generate_excel_for_sales_comparison_report",
  "Zatca Log Report": "bx_block_salesreporting/generate_excel_for_zatca_invoice_logs_report",
  "Weekly Sales Report": "bx_block_salesreporting/generate_excel_for_weekly_sales_report",
  "Monthly Sales Comparison Report": "bx_block_salesreporting/generate_excel_for_monthly_sales_comparison_report",
  "Advance Sales Report": "bx_block_salesreporting/generate_excel_for_advance_sales_report",
  "Advance Sales Redeem Report": "bx_block_salesreporting/generate_excel_for_advance_sales_redeem_report",
  "Carpet Section Orders Report": "bx_block_salesreporting/generate_carpet_orders_excel_report",
   "Finance Laundry Sales & Revenue Report": "bx_block_salesreporting/generate_excel_for_sales_and_revenue_report",
   "Finance Consolidated Sales & Revenue Report": "bx_block_cffinancereport2/generate_finance_report",
}
exports.reportType = {
  "Laundry Sales & Revenue Report": "Sales & Revenue Report",
  "Consolidated Sales & Revenue Report": "Finance Report"
}
exports.getAllRegionEndPoint = "bx_block_regions/regions?dropdown=true&allow_access=true"
exports.getDailySalesFiltersEndPoints = "bx_block_salesreporting/salesreportings/filter_columns_category_wise"
exports.getSectionSalesFiltesEndPoints = "bx_block_salesreporting/filter_columns_for_section_sales"
exports.getStoreListEndPoint =
  "bx_block_store_management/store_managements?dropdown=true&allow_access=true";
exports.top = "top";
exports.totalForEachColumn = "total_for_each_column"
exports.left = "left";
exports.bottom = "bottom";
exports.right = "right";
exports.center = "center";
exports.token = "token";
exports.toDatePlaceholder = "To Date";
exports.fromDataPlaceholder = "From Date";
exports.exportText = "Export";
exports.selectAll = "Select All";
exports.GroupId = "Group Ids";
exports.showOptionsTest = "show-options";
// exports.activeReports = ['Orders Sales Report', 'Orders Revenue Report', 'Laundry Sales & Revenue Report', 'Trend products Sales Report', 'Daily Sales Report', 'Adjustment Report', 'Consolidated Sales & Revenue Report' ]
exports.directFields = ['Orders Sales Report', 'Orders Revenue Report', 'Trend products Sales Report', 'Zatca Log Report','Advance Sales Report','Advance Sales Redeem Report','Carpet Section Orders Report']
exports.revenueFields = ['Laundry Sales & Revenue Report', 'Consolidated Sales & Revenue Report', 'Adjustment Report', 'Daily Sales Report', 'Section & Service Sales Report', 'Promotion Sales Report','Sales Comparison Report', 'Weekly Sales Report', 'Monthly Sales Comparison Report', 'Finance Laundry Sales & Revenue Report','Finance Consolidated Sales & Revenue Report']
exports.dynamicFilterFields = ['Section & Service Sales Report', 'Daily Sales Report']

exports.weekStartDayOptions = [
  { id: "sat", option: "Saturday" },
  { id: "sun", option: "Sunday" },
  { id: "mon", option: "Monday" },
  { id: "tue", option: "Tuesday" },
  { id: "wed", option: "Wednesday" },
  { id: "thu", option: "Thursday" },
  { id: "fri", option: "Friday" }
]
exports.monthOptions = [
  { id: '1', option: 'January' },
  { id: '2', option: 'February' },
  { id: '3', option: 'March' },
  { id: '4', option: 'April' },
  { id: '5', option: 'May' },
  { id: '6', option: 'June' },
  { id: '7', option: 'July' },
  { id: '8', option: 'August' },
  { id: '9', option: 'September' },
  { id: '10', option: 'October' },
  { id: '11', option: 'November' },
  { id: '12', option: 'December' },
]

exports.yearPlaceholder = "Year"
exports.weekStartDayPlaceholder = "Week Start Day"
exports.monthPlaceHolder = "Month"


exports.test = "test"
exports.taskbarTest = "taskbar-test"
// Customizable Area End-